module.exports = __webpack_public_path__ + "img/NichtJederKannSchönSein.90ca2f31.jpg";